import React, { useEffect, useState } from "react";
import styles from "./textMessage.module.scss";
import ChatLike from "../chatLike";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
import { StatusTag } from "../../../../shared/widgets/statusTag";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import { useSelector } from "react-redux";
import { chats, initialStateModel } from "../../../../models/model";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
import { ChatService } from "../../../../base/chatService";
import ForwardHeader from "../forwardHeader";
import { urlify } from "../../../../base/utils";
//import { getdateFormat } from "../../../../base/utils";
type textMessageProps = {
  data: any
  searchedData?: any
  savedData?: any
  previousItem?: any
  timeValue?:any;
}
export default function ChatTextMessage({ data, searchedData, savedData, previousItem,timeValue }: textMessageProps) {
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
  let timeCount = timeValue !== undefined ? timeValue : 18;

  const contactList: any = useSelector((state: initialStateModel) => state.contactReducer);
  let deleteContact = contactList?.deleteContacts;
  //const [visible, setVisible] = useState(false);
  let { message, message_type_value, direction, timestamp, fromcaller_details, id } = data;
  const [longText, setlongtext] = useState(0);
  const handleOnChange = (data: any, direction:string) => {
    if (chatReducer?.multiOption && (direction=== "IN" || direction=== "OUT")) {
      ChatService.selectedMessageDispatch(data);
    }
     else if (chatReducer?.isDelete && direction=== "OUT"){
      ChatService.selectedMessageDispatch(data);
     }
  };
  // const strip = (html: any) => {
  //   let doc = new DOMParser().parseFromString(html, 'text/html');
  //   return doc.body.getElementsByTagName("*")?.length || 0;
  // }


  const handlehighlightHover = () => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.classList.add("highlighthover");
    }
  };


  useEffect(() => {
    var focusableInputElements: any = document.querySelectorAll(".focusText");
    if (focusableInputElements.length > 0 && chatReducer.isSaveChat) {
      focusableInputElements[0].focus();
      focusableInputElements[0].style.outline = "none";
      const textClr:any = document.getElementById('textedited');
      if(textClr !== null ){
       // console.log(chatReducer.isSaveChat,"chatReducer.isSaveChat")
        textClr.focus();
      }
    }
  }, [savedData]);

  try {
    let message_text = data?.message?.body ? data?.message?.body?.toString() : "";
    //let strippedString = message_text.replace(/(<([^>]+)>)/gi, "");
    let mstext = data?.message?.body ? data?.message?.body?.toString() : "";
    // message_text = message_text
    //   ?.replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/img,
    //     '<a href="$1" target="__blank">$1</a>');
    message_text = (searchedData !== "" && searchedData !== undefined) ?message_text:urlify(message_text);
    message_text = message_text?.replace(/\n/g, " ");
    if (searchedData !== "" && searchedData !== undefined && searchedData.search(/[\[\]?*+|{}\\\n\r]/) === -1) {
      var escaped_string = searchedData.replace(/[.*+?^${}()|[\]\\]/g,"\\$&");
      const regexs = new RegExp('(' + escaped_string + ')', 'gi');
      message_text = message_text?.replace(regexs,
        '<span style="background-color:#FBF4C5" tabindex="0" class="tranText">$1</span>');
    }
    if (mstext.length > 760 && longText === 0) {
      mstext = mstext?.replace(/(<[^>]+) style=".*?"/ig, '$1').substring(0, 760) + "...";
    }
    const readMoreChange = ()=>{
      setlongtext(1);
    }
    let noText:any = document.getElementById(id);
      if(noText !== null){
        noText.onclick = () => readMoreChange();
      }
      let isBookmark:any = data?.message?.isSave;
 let widthMulti = (!data?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 ) && data?.message?.isEdit ?"saveEdited": 
 (!data?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 )?"onlySaved": data?.message?.isEdit ? "onlyEdited" : "widthDefault";

    const selectEditMenu = `</strike> <span class='chatReadMore' id=${id}>Read more</span>`
    return (
      <>
        {/* <div className={`${styles.chatMsg} ${styles.leftMessage} ${styles.addBookleftMessage}`}> */}

        {direction === "IN" ? (

          <div className={`${chatReducer.isSaveChat &&
            id === savedData ? 'savedhighlight' : ""
            } ${styles.chatMsg} lftMessage ${styles.leftMessage} ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data) > -1 ) ? "checked" : chatReducer?.multiOption?"checking":""}`} id={id} onClick={() => handleOnChange(data, "IN")}>
            { timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
              <ChatUserInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} className='userinfoIcon leftSide' />
              <div className={styles.convMemName}><span>{fromcaller_details===undefined?'Unknown User':fromcaller_details?.caller_id}</span></div>
            </div>}
            <div className={styles.chatLeftMessages}>
              <div className={styles.chatLeft}>
                {/* {!isReply && <Tooltip mouseEnterDelay={0.5} title={hovertimestamp} className='cusTooltip' overlayClassName='customTooltip'
                >
                  <div className={styles.chatTime}>{htimestamp}</div></Tooltip>} */}
                <div className={`msgContentLft ${styles.chatContent}`}>
                {data?.message?.forward && <ForwardHeader />} 
                  <div className="textContent">
                  {/* {message?.isLink  && 
                      <span className={id === savedData ? "focusText" : ""} tabIndex={0} > 
                     
                     {!searchedData ?<span
                        className={styles.replyMessage}
                        dangerouslySetInnerHTML={{ __html: urlify(mstext) }}
                      ></span> : 
                      
                      <span  className={id===savedData?"focusText":"textmsg" } tabIndex={0} dangerouslySetInnerHTML={{__html: message_text?.replace(/\n/g, "<br />")}}>
                      </span> }
                      
                  </span> } */}
                  { mstext.length > 760 && longText === 0 && 
                    <span className={id === savedData ? "focusText" : "textmsg"} tabIndex={0}> 
                      <span
                        className={styles.replyMessage}
                        dangerouslySetInnerHTML={{ __html: urlify(mstext) + selectEditMenu}}
                      ></span> 
                  </span> }

                  {(( mstext.length < 760) || ( longText === 1)) && 
                  <span  className={id===savedData?"focusText":"textmsg" } tabIndex={0} dangerouslySetInnerHTML={{__html:message_text?.replace(/\n/g, "<br />")}}>
                    
                  </span> }
                           
                    <span className={widthMulti}></span>
                  </div>
                  {message_type_value === "MENTION" ?

                    (<>{
                      data?.mentionMembersdetails?.map((user: any, index: any) => {

                        return (<StatusTag className='statusTag atMentionTag' name={`@ ${user?.caller_id}`} key={index} />);
                      })

                    }</>) : null}
                  <ChatLeftInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} timeStamp={timestamp} message={data}></ChatLeftInfo>

                  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption className='hoverList hoverListleft' data={data} highlightHover={handlehighlightHover} /></div>
                </div>
              </div>
              <ChatLike className='likeLeft' placement="top"
                tooltipTitle={data?.likeduserdetails}
                message={data} />
            </div>

            {(chatReducer?.multiOption && !chatReducer?.isDelete ) && <URCheckBoxCall className="chatSelectRight"
              checked={chatReducer?.selectMessageData?.indexOf(data) > -1 ? true : false} />}
          </div>

        ) : (
          <div onClick={() => handleOnChange(data,"OUT")} className={`${chatReducer.isSaveChat &&
            id === savedData ? 'savedhighlight' : ""
            } rtMessage ${styles.chatMsg} ${styles.rightMessage} 
        ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data) > -1 ) ? "checked" : chatReducer?.multiOption ?"checking":""}`
          } id={id} >
            {timeCount > 15 &&<div className={`${styles.chatUserDetails}`}>
              {/* <ChatRightInfo userDetails = {fromcaller_details} timeStamp = {timestamp}
              message={data}></ChatRightInfo> */}
              <div className={styles.convMemName}><span>You</span></div>
              <ChatUserInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} className='userinfoIcon rightSide' />
            </div>}
           
            <div className={styles.chatRightMessages} >
              <div className={styles.chatRight} >
                <div className={`msgContentRT ${styles.chatContent}`}>
                 {data?.message?.forward && <ForwardHeader />} 
                  <div className="textContent">
               
                  {/* {message?.isLink  && 
                      <span className={id === savedData ? "focusText" : ""} tabIndex={0} > 
                     
                     {!searchedData ?<span
                        className={styles.replyMessage}
                        dangerouslySetInnerHTML={{ __html: urlify(mstext) }}
                      ></span> : 
                      
                      <span  className={id===savedData?"focusText":"textmsg" } tabIndex={0} dangerouslySetInnerHTML={{__html: message_text?.replace(/\n/g, "<br />")}}>
                      </span> }
                      
                  </span> } */}
                  {mstext.length > 760 && longText === 0 && 
                    <span className={id === savedData ? "focusText" : "textmsg"} tabIndex={0}> 
                    <span
                        className={styles.replyMessage}
                        dangerouslySetInnerHTML={{ __html: urlify(mstext) + selectEditMenu}}
                      ></span> 
                    {/* {mstext.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>} */}
                  </span> }

                  {(( mstext.length < 760) || (longText === 1)) && 
                  <span  className={id===savedData?"focusText":"textmsg" } tabIndex={0} dangerouslySetInnerHTML={{__html: message_text?.replace(/\n/g, "<br />")}}>
                    
                  </span> }
               
                    <span className={widthMulti}></span>
                  </div>
                  {message_type_value === "MENTION" ?

                    (<>{
                      data?.mentionMembersdetails.map((user: any, index: any) => {

                        return (<StatusTag className='statusTag atMentionTag' name={`@ ${user?.caller_id}`} key={index} />);
                      })

                    }</>) : null}
                  {/* {data?.message?.isEdit ? ( <span className={styles.edited} >(edited)</span> ):
                  chatReducer.editMessageDetails.message.id?.id === data.id &&
                  <span className={styles.editing}>(editing...)</span>} */}

                  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption className='hoverList hoverListright' data={data} highlightHover={handlehighlightHover} />
                  </div>
                  <ChatRightInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} timeStamp={timestamp}
                    message={data} ></ChatRightInfo>
                </div>


                {/* {!isReply  && <Tooltip mouseEnterDelay={0.5} placement="topRight" title={hovertimestamp}
                className='cusTooltip' overlayClassName='customTooltip'
              >
                <div className={styles.chatTime}>{daysDifference < 5? htimestamp:htimestamp}</div></Tooltip>} */}
              </div>
              <ChatLike className='likeRight' placement="topRight"
                tooltipTitle={data?.likeduserdetails} message={data} />
            </div>



            {/* Need to handle */}
            {(!chatReducer?.isDelete && ( chatReducer?.multiOption)) && <URCheckBoxCall className="chatSelectRight"
              checked={chatReducer?.selectMessageData?.indexOf(data) > -1 ? true : false} />}
          </div>
        )

        }


      </>
    );
  } catch (e) {
    return <p style={{ color: 'red' }}>Something went wrong</p>;
  }
};

